import React from 'react';
import type {
  ComponentProps,
  TableRowElement,
} from '../../../types/aha-editor';
import { isTableCellElement } from '../../../types/guards';

interface TableRowComponentProps extends ComponentProps<TableRowElement> {
  children: React.ReactNode;
}

const TableRowComponent: React.FC<TableRowComponentProps> = ({
  attributes,
  element,
  children,
}) => {
  if (element.children.some(isTableCellElement)) {
    return (
      <tr {...attributes} className="Editor__tr">
        {children}
      </tr>
    );
  }

  return (
    <tr {...attributes} className="Editor__tr">
      <td style={{ display: 'none' }}>{children}</td>
    </tr>
  );
};

export default TableRowComponent;
